<!-- Migrated from legacy/Plus/Plus/Program/index.shtml (2013 event program) -->

<template>
  <h4>Connect With Science</h4>
  <p><strong>30 May 2013 - Museum of Contemporary Art, Sydney</strong></p>
  <table>
    <tbody>
      <tr>
        <td colspan="2"><h5>MCA Forum</h5></td>
      </tr>
      <tr>
        <td>6:45 pm</td>
        <td>Doors open</td>
      </tr>
      <tr>
        <td>7:00 pm</td>
        <td>
          <strong>
            <a href="https://www.wehi.edu.au/education/wehitv/about_wehi-tv">Drew Berry</a>
          </strong>
        </td>
      </tr>
      <tr>
        <td>7:30 pm</td>
        <td><strong><a href="https://www.grahamjlab.org/">Graham Johnson</a></strong></td>
      </tr>
      <tr>
        <td>8:00 pm</td>
        <td><strong>Panel with Graham Johnson &amp; Drew Berry</strong></td>
      </tr>
      <tr>
        <td>8:20 pm</td>
        <td>
          <router-link to="/2013/Showcase/Lightning"><strong>Lightning Talks</strong></router-link>
          <br />
          Invited participants get 30 seconds and one slide each to introduce their work connecting
          science and creativity.
        </td>
      </tr>
      <tr>
        <td colspan="2"><h5>MCA Lounge</h5></td>
      </tr>
      <tr>
        <td>8:30 pm - Late</td>
        <td>Mixer: Meet the speakers &amp; other participants.</td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
h4 {
  font-weight: 600;
  font-size: 1rem;
}
h5 {
  font-weight: 600;
  font-size: 0.95rem;
  margin: 1rem 0 0.3rem;
}
table {
  border-spacing: 8px;
}
td:first-child {
  white-space: nowrap;
  vertical-align: top;
}
</style>
